import axios from 'utils/axios';
import { useCallback, useEffect, useState } from 'react'
import { IRegions } from '../types/regions.interface';
import { IRegionId } from '../types/region.interface';

// type HookNotReadyResult = { ready: false };
// type HookReadyResult<T extends object> = { ready: true } & T;
// type HookResult<T extends object> = HookReadyResult<T> | HookNotReadyResult;

// export type UseRegionsState = HookResult<{
//     regions: IRegions;
//     deleteRegion(regionID: IRegionId): void;
//     deleteRegionInProgress: boolean;
//     restoreRegion(regionID: IRegionId): void;
//     restoreRegionInProgress: boolean;
// }>;

export interface UseRegionsState {
    fetchInProgress: boolean;
    deleteRegionInProgress: boolean;
    deleteRegion(regionID: IRegionId): void;
    restoreRegionInProgress: boolean;
    restoreRegion(regionID: IRegionId): void;
    regions: IRegions;
    ready: boolean;
};

export const useRegions = (deleted: boolean = false) => {
    const [state, setState] = useState<UseRegionsState>({
        fetchInProgress: false,
        deleteRegionInProgress: false,
        deleteRegion: null,
        restoreRegionInProgress: false,
        restoreRegion: null,
        regions: null,
        ready: false
    });

    const fetch = useCallback(async () => {
        setState(s => ({ ...s, fetchInProgress: true }))
        const response = await axios.get<any>('/berryAPI/regions')
        setState(s => ({
          ...s,
          fetchInProgress: false,
          regions: response.data.regions,
          ready: true
        }))
    }, [setState])

    const deleteRegion = useCallback(async (regionID: IRegionId) => {
        setState((s) => ({ ...s, deleteRegionInProgress: true }));
        const updateResponse = await axios.delete(`/berryAPI/regions/${regionID}`);
        setState((s) => ({
            ...s,
            deleteRegionInProgress: false,
            regions: updateResponse.data.regions
        }));
    },
    [setState],
    )

    const restoreRegion = useCallback(async (regionID: IRegionId) => {
        setState((s) => ({ ...s, restoreRegionInProgress: true }));
        const updateResponse = await axios.delete(`/berryAPI/deletedRegions/${regionID}`);
        setState((s) => ({
            ...s,
            restoreRegionInProgress: false,
            regions: updateResponse.data.regions
        }));
    },
    [setState],
    )

    useEffect(() => {
        fetch()
      }, [])

      return { ...state, fetch, deleteRegion, restoreRegion }
    };
